export default __webpack_public_path__ + "static/media/vsmart_logo-sm.3c1b7f7d.svg";